// extracted by mini-css-extract-plugin
export default {"date-grid":"DateGrid_date-grid__TqQrf","days-of-the-week":"DateGrid_days-of-the-week__oWgqj"};